export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            {Array(cols).fill(0).map((_, i) => (
              <th key={i}><div className="skeleton" style={{ height: 10, width: '60%' }} /></th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array(rows).fill(0).map((_, r) => (
            <tr key={r}>
              {Array(cols).fill(0).map((_, c) => (
                <td key={c}><div className="skeleton" style={{ height: 14, width: `${50 + (r * 13 + c * 7) % 40}%` }} /></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export function CardGridSkeleton({ cards = 4 }: { cards?: number }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
      {Array(cards).fill(0).map((_, i) => (
        <div key={i} className="card" style={{ padding: 18 }}>
          <div className="skeleton" style={{ height: 16, width: '70%', marginBottom: 8 }} />
          <div className="skeleton" style={{ height: 12, width: '50%', marginBottom: 16 }} />
          <div style={{ display: 'flex', gap: 16 }}>
            <div className="skeleton" style={{ height: 32, width: 48 }} />
            <div className="skeleton" style={{ height: 32, width: 48 }} />
            <div className="skeleton" style={{ height: 32, width: 48 }} />
          </div>
        </div>
      ))}
    </div>
  )
}

export function StatsSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${count}, 1fr)`, gap: 10 }}>
      {Array(count).fill(0).map((_, i) => (
        <div key={i} className="card" style={{ padding: 16 }}>
          <div className="skeleton" style={{ height: 10, width: '50%', marginBottom: 8 }} />
          <div className="skeleton" style={{ height: 28, width: '60%', marginBottom: 8 }} />
          <div className="skeleton" style={{ height: 10, width: '70%' }} />
        </div>
      ))}
    </div>
  )
}

export function KanbanSkeleton({ cols = 5 }: { cols?: number }) {
  return (
    <div className="flex gap-4 overflow-x-auto pb-4" style={{ minHeight: 400 }}>
      {Array(cols).fill(0).map((_, i) => (
        <div key={i} className="flex-shrink-0" style={{ width: 280 }}>
          <div className="flex items-center gap-2 mb-3">
            <div className="skeleton" style={{ width: 8, height: 8, borderRadius: '50%' }} />
            <div className="skeleton" style={{ height: 14, width: 60 }} />
          </div>
          <div className="space-y-2">
            {Array(2 + (i % 3)).fill(0).map((_, j) => (
              <div key={j} className="card" style={{ padding: 12 }}>
                <div className="skeleton" style={{ height: 14, width: '80%', marginBottom: 8 }} />
                <div className="skeleton" style={{ height: 12, width: '50%' }} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
